export default __webpack_public_path__ + "static/media/purple beret.3c9fc4c7.png";